import { Flex, Heading } from '@radix-ui/themes';
import { NotifyHelper } from 'classes/helpers/notify.helper';
import { ErrorBoundary } from 'components/common/error-boundary';
import { MachinePositionView } from 'components/machine/position-view';
import { ChartsDemo } from 'components/sections/feature-demo/charts';
import { InputsDemo } from 'components/sections/feature-demo/inputs';
import { RealTimeApiTest } from 'components/sections/feature-demo/integrations/real-time-api';
import { CalloutsDemo } from 'components/sections/feature-demo/miscellaneous/callouts';
import { CustomIconsDemo } from 'components/sections/feature-demo/miscellaneous/custom-icons';
import { ToastsDemo } from 'components/sections/feature-demo/miscellaneous/toasts';
import { ProcessesDemo } from 'components/sections/feature-demo/processes';
import { SectionBox } from 'components/sections/feature-demo/section-box';
import { SubSectionBox } from 'components/sections/feature-demo/sub-section-box';
import { SectionHeader } from 'components/sections/header';
import { t } from 'i18next';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useCallback } from 'react';
import './index.scss';

export const FeatureDemo = () => {
  const onUpdateMachinePosition = useCallback(
    (pos: { px: number; pz: number }) => {
      console.debug(
        `FeatureDemo: received machine position (${pos.px}, ${pos.pz})`
      );
    },
    []
  );

  // MARK: render
  return (
    <ErrorBoundary identifier="FeatureDemo">
      <Flex direction="column" gap={RADIX.FLEX.GAP.SECTION}>
        <SectionHeader
          header={t('main.feature-demo')}
          onClick={() => {
            NotifyHelper.haveFun();
          }}
        />

        <SectionBox>
          <Heading size={RADIX.HEADING.SIZE.MD}>Charts</Heading>
          <ChartsDemo />
        </SectionBox>

        <SectionBox>
          <Heading size={RADIX.HEADING.SIZE.MD}>Inputs</Heading>
          <InputsDemo />
        </SectionBox>

        <SectionBox>
          <Heading size={RADIX.HEADING.SIZE.MD}>Integrations</Heading>

          <RealTimeApiTest />
        </SectionBox>

        <SectionBox>
          <Heading size={RADIX.HEADING.SIZE.MD}>Miscellaneous</Heading>

          <CalloutsDemo />
          <CustomIconsDemo />

          <SubSectionBox
            title="Machine Position"
            source="machine/position-view"
          >
            <MachinePositionView onUpdate={onUpdateMachinePosition} />
          </SubSectionBox>
          <ProcessesDemo />
          <ToastsDemo />
        </SectionBox>
      </Flex>
    </ErrorBoundary>
  );
};
